module.exports = __webpack_public_path__ + "img/isLimited.4a3048da.png";